/**
Coded by www.techhighway.ca

*/

import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import * as React from "react";

// prop-types is a library for typechecking of props

// Custom styles for MDMultipleSelect
import MDSelectRoot from "components/MDMultipleSelect/MDSelectRoot";

// Material Dashboard 2 React contexts
import { Typography } from "@mui/material";
import { useMaterialUIController } from "context";

const MDMultipleSelect = React.forwardRef(
  ({ label, name, value, options, onChange, disabled, required, size, ...rest }, ref) => {
    const [controller] = useMaterialUIController();
    const preSelectOption = options || [];
    let selectOption = [];
    const optionsArray = [];
    let allOption = null;

    // preSelectOption?.map((eachOption, index) => {
    //   optionsArray[eachOption.key] = eachOption.value;
    //   if (value.includes(eachOption.key)) {
    //     selectOption = [eachOption, ...selectOption];
    //   } else {
    //     selectOption.push(eachOption);
    //   }
    // });

    preSelectOption?.forEach((eachOption) => {
      optionsArray[eachOption.key] = eachOption.value;
      if (eachOption.key === "All") {
        allOption = eachOption; // Store the 'All' option separately
      } else {
        selectOption.push(eachOption); // Push other options to selectOption
      }
    });

    // Sort the remaining options based on whether they are selected
    selectOption.sort((a, b) => {
      const aSelected = value.includes(a.key);
      const bSelected = value.includes(b.key);
      return bSelected - aSelected; // Sort selected options to the top
    });

    // Combine the 'All' option with the sorted options
    if (allOption) {
      selectOption = [allOption, ...selectOption];
    }
    const ITEM_HEIGHT = 50;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };

    return (
      <Box>
        <FormControl size={size} fullWidth>
          <InputLabel id="demo-multiple-checkbox-label">
            {label} {required ? "*" : ""}
          </InputLabel>
          <MDSelectRoot
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            name={name}
            value={value}
            onChange={onChange}
            input={<OutlinedInput label={label} />}
            renderValue={(selected) =>
              selected.map((value, index) => {
                return optionsArray[value] + (selected.length - 1 != index ? ", " : "");
              })
            }
            MenuProps={MenuProps}
            disabled={disabled}
            required={required}
            {...rest}
            ownerState={{ disabled }}
          >
            {selectOption?.map((eachOption) => (
              <MenuItem sx={{ height: "2rem", px: 0, borderRadius: 0 }} value={eachOption.key}>
                <Checkbox checked={value.indexOf(eachOption.key) > -1} />
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: "1rem" }}>
                      {" "}
                      {/* Adjust font size here */}
                      {eachOption.value}
                    </Typography>
                  }
                />
              </MenuItem>
            ))}
          </MDSelectRoot>
        </FormControl>
      </Box>
    );
  }
);

// Setting default values for the props of MDMultipleSelect
MDMultipleSelect.defaultProps = {
  disabled: false,
  required: false,
  size: "small",
};

export default MDMultipleSelect;
